// extracted by mini-css-extract-plugin
export default {"container":"SXk4AY","badge":"zuoJvz","icon":"R0zAa8","name":"zR9EqN","title":"_KlYqw","description":"CL1JE6","descriptionTypeBold":"yrcU3P","button":"FwkE6Q"};